import EmblaCarousel from 'embla-carousel';

document.addEventListener('DOMContentLoaded', () => {
  const emblaWrappers = document.querySelectorAll('.embla-wrapper');
  if (!emblaWrappers.length) return;

  emblaWrappers.forEach((wrapper) => {
    const emblaNode = wrapper.querySelector('.embla');
    const prevBtn = wrapper.querySelector('.embla__prev');
    const nextBtn = wrapper.querySelector('.embla__next');
    const progressBar = wrapper.querySelector('.embla__progress__bar');

    const embla = EmblaCarousel(emblaNode, {
      loop: false,
      align: 'start',
      skipSnaps: false,
      containScroll: 'trimSnaps'
    });

    // Prev/Next buttons
    if (prevBtn) prevBtn.addEventListener('click', embla.scrollPrev);
    if (nextBtn) nextBtn.addEventListener('click', embla.scrollNext);

    // Progress Bar
    if (progressBar) {
      const applyProgressBar = () => {
        const scrollProgress = embla.scrollProgress();
        const percent = Math.max(0, Math.min(1, scrollProgress)) * 100;
        progressBar.style.transform = `translate3d(${percent}%,0,0)`;
      };

      embla.on('scroll', applyProgressBar);
      embla.on('reInit', applyProgressBar);
      applyProgressBar();
    }

  });
});